import { Component, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../../domains/auth/services/auth.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";


@Component({
  selector: "top-bar",
  styleUrls: ['./top-bar.component.scss'],
  templateUrl: "./top-bar.component.html",
})
export class TopBarComponent {

  constructor(
      private readonly routerService: Router,
      private readonly authService: AuthService,
      private modalService: BsModalService,
  ) {}

  currentRoute = this.routerService.url;
  isLoggedIn = this.authService.isLoggedIn();
  user = this.authService.getCurrentUser();
  isUserMenu = this.routerService.url === "/user-menu";
  institutionalModalRef: BsModalRef = new BsModalRef<any>();

  async logoutUser() {
    await this.authService.logout();
    if (this.isInHome()) {
      window.location.reload();
    } else {
      await this.routerService.navigate([""]);
    }
  }

  isInHome() {
    return this.currentRoute === "/" || this.currentRoute === "/home";
  }

  openModal(template: TemplateRef<any>) {
    this.institutionalModalRef = this.modalService.show(template);
  }

  openDashboard() {
    if (this.user["type"] === "owner") {
      this.routerService.navigate(["dashboard/owner"]);
    } else if (this.user["type"] === "leader") {
      this.routerService.navigate(["dashboard/leader"]);
    } else {
      this.routerService.navigate(["dashboard/user"]);
    }
  }
}


